module.exports = __webpack_public_path__ + "media/images/setting/Icon10-b7b392270935636f7e2e60156d5e4f3e.svg";